<template>
  <section class="workspace-stack">
    <article class="glass-surface workspace-panel">
      <div class="workspace-panel__header">
        <div>
          <span class="workspace-kicker">Finanzas del evento</span>
          <h2 class="workspace-title">{{ canViewInternalFinance ? 'Resumen financiero y depositos' : 'Lo que llevas ganado y tus depositos' }}</h2>
          <p class="workspace-copy">{{ canViewInternalFinance ? 'Aqui ves el movimiento principal del evento y los depositos ya registrados.' : 'Aqui ves lo que ya te corresponde, lo depositado y lo pendiente. Los fees internos y costos de pasarela quedan solo en admin FOMO.' }}</p>
        </div>

        <div v-if="canViewInternalFinance" :class="['finance-health', { 'finance-health--ok': event.ledger_is_reconciled, 'finance-health--warn': !event.ledger_is_reconciled }]">
          <small>{{ event.ledger_is_reconciled ? 'Ledger reconciliado' : 'Ledger por revisar' }}</small>
          <strong>{{ event.ledger_is_reconciled ? 'OK' : `${event.ledger_missing_posted_payments} faltantes` }}</strong>
          <span>{{ ledgerHealthCopy }}</span>
        </div>
      </div>

      <div class="workspace-metrics">
        <article class="workspace-metric">
          <small>{{ canViewInternalFinance ? 'Ventas ticket' : 'Ganancia organizer' }}</small>
          <strong>${{ formatMoney(canViewInternalFinance ? event.total_ticket_sales : event.ledger_organizer_sales_gross) }}</strong>
        </article>
        <article v-if="canViewInternalFinance" class="workspace-metric">
          <small>Fee FOMO</small>
          <strong>${{ formatMoney(event.ledger_platform_fee_gross) }}</strong>
        </article>
        <article v-if="canViewInternalFinance" class="workspace-metric">
          <small>Fomo Safe</small>
          <strong>${{ formatMoney(event.ledger_fomo_safe_gross) }}</strong>
        </article>
        <article v-if="canViewInternalFinance" class="workspace-metric">
          <small>Costo pasarela</small>
          <strong>${{ formatMoney(event.ledger_processor_fee_total) }}</strong>
        </article>
        <article class="workspace-metric">
          <small>Pendiente host</small>
          <strong>${{ formatMoney(event.ledger_organizer_pending) }}</strong>
        </article>
        <article class="workspace-metric">
          <small>Depositado host</small>
          <strong>${{ formatMoney(event.ledger_organizer_deposited) }}</strong>
        </article>
        <article class="workspace-metric">
          <small>Depositos</small>
          <strong>{{ deposits.length }}</strong>
        </article>
        <article v-if="!canViewInternalFinance" class="workspace-metric">
          <small>Ventas ticket</small>
          <strong>${{ formatMoney(event.total_ticket_sales) }}</strong>
        </article>
      </div>

      <div v-if="canViewInternalFinance" class="finance-health-grid">
        <article class="finance-health-card">
          <small>Pagos aprobados</small>
          <strong>{{ event.ledger_approved_payments || 0 }}</strong>
          <span>Total de pagos `status=1` del evento.</span>
        </article>
        <article class="finance-health-card">
          <small>Asientos posteados</small>
          <strong>{{ event.ledger_posted_payments || 0 }}</strong>
          <span>Pagos aprobados que ya entraron al ledger.</span>
        </article>
        <article class="finance-health-card">
          <small>Aprobados 0.00</small>
          <strong>{{ event.ledger_zero_value_approved_payments || 0 }}</strong>
          <span>Free/cortesias o aprobados sin monto contable.</span>
        </article>
        <article class="finance-health-card">
          <small>Faltantes reales</small>
          <strong>{{ event.ledger_missing_posted_payments || 0 }}</strong>
          <span>Diferencia neta que si deberia existir en ledger.</span>
        </article>
      </div>

      <div v-if="loading && !deposits.length" class="workspace-empty">Cargando depositos...</div>
      <div v-else-if="!deposits.length" class="workspace-empty">Aun no hay depositos registrados para este evento.</div>
      <div v-else class="workspace-table-shell">
        <table class="workspace-table">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Banco</th>
              <th>Cuenta</th>
              <th>Monto</th>
              <th>Comentario</th>
              <th>Archivo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="deposit in deposits" :key="deposit.id">
              <td>{{ formatDate(deposit.date) }}</td>
              <td>{{ deposit.account.bank_name }}</td>
              <td>{{ deposit.account.number }}</td>
              <td>${{ formatMoney(deposit.amount) }}</td>
              <td>{{ deposit.comment || 'Sin comentario' }}</td>
              <td><a class="workspace-inline-link" :href="deposit.file" target="_blank">Descargar</a></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="workspace-actions workspace-actions--end">
        <spring-spinner v-if="loading" v-show="next" :size="48" color="#8cf3e8" />
        <button v-show="next && !loading" class="workspace-button" type="button" @click="getDeposits">Cargar mas</button>
      </div>
    </article>
  </section>
</template>

<script>
import { apiService } from '../../common/api.services.js'
import { SpringSpinner } from 'epic-spinners'

export default {
  name: 'EventFinance',

  components: {
    SpringSpinner,
  },

  props: {
    event: {
      required: true,
    },
  },

  data() {
    return {
      deposits: [],
      next: null,
      loading: false,
    }
  },

  created() {
    this.getDeposits()
  },

  watch: {
    event: {
      deep: true,
      handler() {
        this.deposits = []
        this.next = null
        this.getDeposits()
      },
    },
  },

  methods: {
    formatCount(value) {
      const parsed = Number.parseInt(value, 10)
      return Number.isNaN(parsed) ? 0 : parsed
    },

    formatDate(value) {
      if (!value) {
        return 'Sin fecha'
      }

      return new Intl.DateTimeFormat('default', { dateStyle: 'medium' }).format(new Date(value))
    },

    formatMoney(value) {
      const parsed = Number.parseFloat(value)
      return Number.isNaN(parsed) ? '0.00' : parsed.toFixed(2)
    },

    getDeposits() {
      if (!this.event || !this.event.id) {
        return
      }

      this.loading = true
      let endpoint = `/api/deposits/?event=${this.event.id}`
      if (this.next) {
        endpoint = this.next
      }

      apiService(endpoint).then((data) => {
        const items = Array.isArray(data) ? data : (data && data.results ? data.results : [])
        this.deposits = this.deposits.concat(items)
        this.next = data && data.next ? data.next : null
      }).finally(() => {
        this.loading = false
      })
    },
  },

  computed: {
    canViewInternalFinance() {
      return Boolean(this.event && this.event.can_view_internal_finance)
    },

    ledgerHealthCopy() {
      const missing = this.formatCount(this.event.ledger_missing_posted_payments)
      const skipped = this.formatCount(this.event.ledger_zero_value_approved_payments)
      const posted = this.formatCount(this.event.ledger_posted_payments)

      if (missing === 0) {
        return skipped > 0
          ? `${posted} pagos monetarios posteados y ${skipped} aprobados 0.00 omitidos por diseno.`
          : `${posted} pagos monetarios ya reconciliados en ledger.`
      }

      return `${posted} pagos posteados, ${skipped} aprobados 0.00 omitidos y ${missing} pagos monetarios aun sin asiento.`
    },
  },
}
</script>

<style scoped>
.finance-health,
.finance-health-card {
  display: grid;
  gap: 4px;
  padding: 14px 16px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(223, 214, 255, 0.08);
}

.finance-health {
  max-width: 320px;
}

.finance-health--ok {
  border-color: rgba(140, 243, 232, 0.28);
  box-shadow: inset 0 0 0 1px rgba(140, 243, 232, 0.08);
}

.finance-health--warn {
  border-color: rgba(255, 193, 122, 0.28);
  box-shadow: inset 0 0 0 1px rgba(255, 193, 122, 0.08);
}

.finance-health small,
.finance-health-card small {
  color: rgba(208, 219, 238, 0.72);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.finance-health strong,
.finance-health-card strong {
  color: var(--text-main);
  font-size: 1.45rem;
  line-height: 1;
}

.finance-health span,
.finance-health-card span {
  color: var(--text-soft);
  line-height: 1.45;
}

.finance-health-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.workspace-table-shell {
  overflow: auto;
}

.workspace-table {
  width: 100%;
  border-collapse: collapse;
}

.workspace-table th,
.workspace-table td {
  padding: 14px 12px;
  border-bottom: 1px solid rgba(223, 214, 255, 0.08);
  text-align: left;
  color: var(--text-soft);
}

.workspace-table th {
  color: var(--text-main);
  font-size: 0.75rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.workspace-inline-link {
  color: #cbffe8;
}

@media (max-width: 960px) {
  .finance-health-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .finance-health-grid {
    grid-template-columns: 1fr;
  }
}
</style>
